import { render, staticRenderFns } from "./SlimeBlocks.vue?vue&type=template&id=d1916b74"
import script from "./SlimeBlocks.vue?vue&type=script&lang=js"
export * from "./SlimeBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports